import { CommandType } from "~app/common/services/cqs/CommandType";
import { BasicCommand } from "../../../../common/services/cqs/BasicCommand";
import { IAvtalPrimaryKey } from "../avtal/AvtalCommandBase";

export class LeverantorCommandBase extends BasicCommand<LeverantorCommandBase> {
    avtalGuid: string;
    leverantorGuid: string;

    // eslint-disable-next-line sonarjs/public-static-readonly
    static $groupKey = "Virkesleverantor";

    get primaryKey(): ILeverantorPrimaryKey {
        return {
            avtalGuid: this.avtalGuid,
            leverantorGuid: this.leverantorGuid
        };
    }

    constructor(avtalGuid: string, leverantorGuid: string, type: string, commandType: CommandType) {
        super(type, LeverantorCommandBase.$groupKey, commandType);
        this.avtalGuid = avtalGuid;
        this.leverantorGuid = leverantorGuid;
    }
}

export interface ILeverantorPrimaryKey extends IAvtalPrimaryKey {
    leverantorGuid: string;
}
